import React, { Component } from 'react';

export default function PdmiCredentialsHOC(PdmiCredentials) {
  class PdmiCredentialsWrapper extends Component {
    _onSubmit = async event => {
      const { username, password, passwordConfirmation } = event;//eslint-disable-line
    };

    // _checkPassword = async event => {
    //   event.password === event.passwordConfirmation ?
    // }

    render() {
      return <PdmiCredentials onSubmit={this._onSubmit} />;
    }
  }
  return PdmiCredentialsWrapper;
}



// WEBPACK FOOTER //
// ./src/pages/PdmiCredentials/PdmiCredentialsHOC.jsx